// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UntrustedView__container-b733f1 {
  max-height: 620px;
  height: 100%;
}

.UntrustedView__content-f52887 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.UntrustedView__button-back-d446cf {
  position: absolute;
  top: 20px;
  inset-inline-start: 20px;
}

.UntrustedView__title-dfa9ca {
  padding: 16px 0;
  font: var(--font-title-6);
  letter-spacing: var(--font-spacing-title-6);
  color: var(--base-110);
  text-align: center;
}

.UntrustedView__subtitle-d47f7e {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-120);
  text-align: center;
}

.UntrustedView__logo-d20d96 {
  width: 120px;
  height: 120px;
  margin: 24px 0;
}

.UntrustedView__footer-e7dfb7 {
  display: flex;
  margin-top: auto;
  padding: 24px 0 32px 0;
  text-align: center;
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/authorization/UntrustedView/UntrustedView.styles.m.css"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,wBAAA;AACF;;AAEA;EACE,eAAA;EACA,yBAAA;EACA,2CAAA;EACA,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,4BAAA;EACA,8CAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;AACF","sourcesContent":[".container {\n  max-height: 620px;\n  height: 100%;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.button-back {\n  position: absolute;\n  top: 20px;\n  inset-inline-start: 20px;\n}\n\n.title {\n  padding: 16px 0;\n  font: var(--font-title-6);\n  letter-spacing: var(--font-spacing-title-6);\n  color: var(--base-110);\n  text-align: center;\n}\n\n.subtitle {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-120);\n  text-align: center;\n}\n\n.logo {\n  width: 120px;\n  height: 120px;\n  margin: 24px 0;\n}\n\n.footer {\n  display: flex;\n  margin-top: auto;\n  padding: 24px 0 32px 0;\n  text-align: center;\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n  justify-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UntrustedView__container-b733f1`,
	"content": `UntrustedView__content-f52887`,
	"button-back": `UntrustedView__button-back-d446cf`,
	"buttonBack": `UntrustedView__button-back-d446cf`,
	"title": `UntrustedView__title-dfa9ca`,
	"subtitle": `UntrustedView__subtitle-d47f7e`,
	"logo": `UntrustedView__logo-d20d96`,
	"footer": `UntrustedView__footer-e7dfb7`
};
module.exports = ___CSS_LOADER_EXPORT___;
